import { render, staticRenderFns } from "./toothPosition.vue?vue&type=template&id=9bece01c&scoped=true&"
import script from "./toothPosition.vue?vue&type=script&lang=js&"
export * from "./toothPosition.vue?vue&type=script&lang=js&"
import style0 from "./toothPosition.vue?vue&type=style&index=0&id=9bece01c&prod&lang=scss&scoped=true&"
import style1 from "./toothPosition.vue?vue&type=style&index=1&id=9bece01c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bece01c",
  null
  
)

export default component.exports